export default __webpack_public_path__ + "static/media/mihika.990f657d.jpg";